import { type ReactElement } from 'react';
import { PaginatedTable } from '@avanta/shared/components/PaginatedTable';
import { type FilterValue } from '@avanta/shared/types/table';
import { type PaginatedTableProps } from './types';
import { useClientPaginatedTable } from './useClientPaginatedTable';

const ClientPaginatedTable = <T, K extends FilterValue = FilterValue>({
  data,
  columns,
  pageSize,
  initialSorting,
  initialDateRange,
  filter,
  onFilterChange,
  dateRangeFilter,
  renderSubtitle,
  subtitle,
  ...props
}: PaginatedTableProps<T, K>): ReactElement => {
  const { table, filteredCount, selectedFilterKey, setFilter, selectedDateRange, setDateRange } =
    useClientPaginatedTable({
      data,
      columns,
      pageSize,
      initialSorting,
      initialDateRange,
      filter,
      onFilterChange,
      dateRangeFilter,
    });

  return (
    <PaginatedTable<T, K>
      table={table}
      columns={columns}
      filter={filter}
      selectedFilterKey={selectedFilterKey}
      setFilter={setFilter}
      dateRangeFilter={dateRangeFilter}
      selectedDateRange={selectedDateRange}
      setDateRange={setDateRange}
      pageSize={pageSize}
      {...props}
      subtitle={renderSubtitle ? renderSubtitle(filteredCount) : subtitle}
    />
  );
};

export { ClientPaginatedTable };
